<script setup>
import { cdnImageUrl } from '@dpgradio/creative'

defineProps({
  item: Object,
})

const view = ref(null)

const { onDisappear } = useDisappearable()

onMounted(() => {
  gsap.timeline().from(view.value, { opacity: 0, duration: 1 }, '<.5').to(view.value, { opacity: 1, duration: 1 })
})

onDisappear(async () => {
  await gsap.to(view.value, { opacity: 0, duration: 0.8 })
})
</script>

<template>
  <div v-if="item.enrichment.track" ref="view" class="h-full w-full flex items-center z-10 justify-center space-x-16">
    <div class="h-[550px] w-[550px]">
      <img v-if="item.enrichment.track.thumbnail" :src="cdnImageUrl(item.enrichment.track.thumbnail, 'w800')" class="w-full h-full object-cover" />
    </div>
    <div class="text-white space-y-6 w-[800px]">
      <h1 class="text-[90px] font-bold font-rift uppercase leading-[90px]">{{ item.enrichment.track.title }}</h1>
      <h2 class="text-[70px] leading-[70px]">{{ item.enrichment.track.artist.name }}</h2>
    </div>
  </div>
</template>
